import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import {
  DEALCHECKOUTDATA,
  DEALEXPRESSPAYMENTMETHOD,
} from '../config/setup/setup';
import errorTrackingService from '../helpers/errorTrackingService';
import httpCommonHeaders from '../helpers/httpCommonHeaders';

export const fetchDealExpressPayment = async (id) => {
  try {
    const { data } = await axios(DEALEXPRESSPAYMENTMETHOD(id), {
      headers: httpCommonHeaders(),
      method: 'GET',
      withCredentials: true,
    });

    return data;
  } catch (error) {
    console.error(error);
    errorTrackingService.logError(error);

    return {};
  }
};

export const fetchDealOrderSummary = async (dealData) => {
  try {
    const { data } = await axios({
      cache: false,
      data: dealData,
      headers: httpCommonHeaders(),
      method: 'POST',
      url: DEALCHECKOUTDATA,
      withCredentials: true,
    });

    return data;
  } catch (error) {
    console?.error(error);
    errorTrackingService?.logError(error);

    return {};
  }
};

export const dealProductBuilder = (
  deal,
  locations,
  position = 0,
  isAGift = false,
  quantity = -1,
  payDeposit = false,
  deposit = false,
) => {
  const product = deal?.products[Number.parseInt(position, 10)];
  const isPPDeal = deal?.pricePerPerson;

  const getProductQuantity = () => {
    let productQuantity = quantity >= 0 ? quantity : product?.quantity || 1;

    if (isPPDeal && productQuantity === 1) {
      productQuantity = 2;
    }

    return productQuantity;
  };

  return {
    bookingCalendarOnRedemption: deal?.bookingCalendarOnRedemption || false,
    checkInDate: product?.checkInDate || null,
    checkOutDate: product?.checkOutDate || null,
    dealId: deal?.id,
    dealType: deal?.productDisplay?.type || 'default',
    dealVoucherProductId: product?.id,
    depositDisplayPrice: product?.depositProduct?.price || null,
    // depositProduct: product?.depositProduct || null,
    // depositProductId: product?.depositProduct?.id || null,
    // discount: product?.discount,
    // discountPercentage: product?.discountPercentage,
    // discountValue: product?.discount,
    // displayDiscount: product?.displayDiscount,
    flights: product?.flights || null,
    // gift: isAGift,
    // giftClaim: deal?.giftClaim || false,
    // gifting: giftingBuilder(deal.deliveryType || false, isAGift),
    hasDeposit: product?.hasDeposit,
    // hideProductDiscount: !product?.displayDiscount,
    id: product?.id,
    numberOfNights: product?.numberOfNights,
    // originalPrice: product?.originalPrice,
    // payDeposit: product?.payDeposit || product?.isDepositOption || payDeposit,
    payDeposit: deposit,
    postagePrice: product?.postagePrice,
    price: product?.price,
    // purchaseCap: product?.purchaseCap,
    // purchaseGclid: Cookies.load(COOKIES.gclid) || null,
    purchaseLocation: locations?.location?.shortName,
    // purchaseUrl: Cookies.load(COOKIES.purchaseUrl),
    quantity: getProductQuantity(),
  };
};

export const getTotalQuantityForDealItems = (newProducts) => {
  let quantity = 0;
  quantity = newProducts?.reduce(
    (total, product) => total + product.quantity,
    0,
  );

  return quantity;
};

export const fetchExpressCheckoutDealData = async (
  selectedOptions,
  position,
  isOptionSelected,
  selection,
  deal,
  locationStore,
  deposit,
) => {
  const selectedPosition = selectedOptions || [];
  const sumOfSelectedPosition = selectedPosition.reduce(
    (accumulator, current) => accumulator + current,
    0,
  );
  const payDeposit = deal?.depositAvailable || false;
  const isAGift = false;
  let newProducts = [];

  if (Array.isArray(selectedPosition) && selectedPosition.length > 0) {
    if (sumOfSelectedPosition >= 1) {
      newProducts = selectedPosition
        .map((item, index) =>
          item !== 0
            ? dealProductBuilder(
                deal,
                locationStore,
                index,
                isAGift,
                Number.parseInt(item, 10),
                payDeposit,
              )
            : null,
        )
        .filter((product) => product !== null);
    } else if (position > -1) {
      newProducts.push(
        dealProductBuilder(
          deal,
          locationStore,
          position,
          isAGift,
          1,
          payDeposit,
        ),
      );
    } else {
      newProducts.push(
        dealProductBuilder(deal, locationStore, 0, isAGift, 1, payDeposit),
      );
    }
  } else if (isOptionSelected) {
    newProducts.push(
      dealProductBuilder(deal, locationStore, 0, false, 1, payDeposit, deposit),
    );
  } else {
    newProducts.push(
      dealProductBuilder(deal, locationStore, selectedPosition, -1, payDeposit),
    );
  }

  const dealData = {
    dealId: deal?.id,
    dealProducts: newProducts,
    deliveryOptions: true,
    purchaseSource: 'kc-test',
    showDeliveryOptions: true,
    webClientSupportsPoR: true,
  };

  try {
    return await fetchDealOrderSummary(dealData);
  } catch (error) {
    console.error('Error fetching deal order summary:', error);
    throw error;
  }
};
